export enum MarketSide {
  Flat = 0,
  Buy = 1,
  Sell = -1
}
